import styled from 'styled-components';

export const Main = styled.div`
    width: 150px;
    padding: 0;
`;

export const Styled = styled.div`
    .select {
        margin-bottom: 10px;
        h4 { width: 65px; }
    }
    
    .textInput {
        margin-bottom: 10px;
        h4 { width: 85px; }
        
        &:last-of-type {
            margin-bottom: 0;
        }
        border-radius: 10px;
    }
    
    textarea {
        padding: 20px;
        font-size: 15px;
        min-height: 100px;
    }
    
    .params, .headers {
        margin-top: 25px;
    }
`;

// Custom Input Section Styles
export const CustomInputSection = styled.div`
    margin-top: 20px;
`;

export const InputFormatHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    gap: 8px;
    
    h3 {
        margin: 0;
        font-size: 14px;
        font-weight: 500;
        color: #374151;
    }
`;

export const InfoIcon = styled.div`
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid #d1d5db;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: #6b7280;
    cursor: help;
    position: relative;
`;

export const Tooltip = styled.div`
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #1f2937;
    color: white;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 15px;
    z-index: 1000;
    margin-bottom: 4px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    max-width: 200px;
    width: 200px;
    white-space: normal;
    text-align: center;
    
    &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid #1f2937;
    }
`;

export const ScrollableFieldsContainer = styled.div`
    max-height: 300px;
    overflow-y: auto;
    padding-right: 4px;
    
    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
        
        &:hover {
            background: #a8a8a8;
        }
    }
`;

export const FieldContainer = styled.div`
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    background-color: #f9fafb;
`;

export const FieldHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    
    span {
        font-size: 15px;
        font-weight: 500;
        color: #6b7280;
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 8px;
`;

export const ActionButton = styled.button`
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    
    &.add-btn {
        background-color: #f3f4f6;
        color: #374151;
        
        &:hover {
            background-color: #e5e7eb;
        }
    }
    
    &.remove-btn {
        background-color: #fee2e2;
        color: #dc2626;
        
        &:hover {
            background-color: #fecaca;
        }
    }
`;

export const FieldGroup = styled.div`
    margin-bottom: 12px;
    
    &:last-child {
        margin-bottom: 0;
    }
    
    label {
        display: block;
        font-size: 15px;
        font-weight: 500;
        color: #374151;
        margin-bottom: 4px;
    }
`;